import { defineComponent } from "vue";
import ApplyStageLabelIcon from "../../../common/icons/ApplyStageLabelIcon.vue.mjs";
import useMasterApplyControl from "../../../../hooks/useMasterApplyControl.mjs";
import Avatar from "../../../common/Avatar.vue.mjs";
import Dialog from "../../../common/base/Dialog/index.mjs";
import SvgIcon from "../../../common/base/SvgIcon.vue.mjs";
import TuiButton from "../../../common/base/Button.vue.mjs";
import "../../../../services/main.mjs";
import { roomService } from "../../../../services/roomService.mjs";
import "../../../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../../utils/environment.mjs";
import "mitt";
import "../../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MasterApplyControlPC",
  setup(__props) {
    const {
      t,
      showApplyUserList,
      hideApplyList,
      applyToAnchorUserCount,
      applyToAnchorList,
      handleAllUserApply,
      handleUserApply
    } = useMasterApplyControl();
    return { __sfc: true, t, showApplyUserList, hideApplyList, applyToAnchorUserCount, applyToAnchorList, handleAllUserApply, handleUserApply, ApplyStageLabelIcon, Avatar, Dialog, SvgIcon, TuiButton, roomService };
  }
});
export {
  _sfc_main as default
};
